<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('EREPORTER.PAYROLLS.ITEM') }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
        <v-btn
          class="ml-2"
          color="primary"
          @click="
            $router.push({
              name: 'ereporter.payroll.edit',
              params: { id: id }
            })
          "
        >
          {{ $t('BUTTON.EDIT') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>
    <v-card class="mt-3" :loading="loading">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <payroll-form
              v-if="Object.keys(payroll).length"
              v-model="payroll"
              :employee="employee"
              readonly
            ></payroll-form>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <payrolls-task-list
              class="mt-5 pa-5"
              :tasks="payroll.tasks"
              :total-duration="payroll.duration"
              @show="show"
            ></payrolls-task-list>
            <v-dialog v-model="dialog" persistent max-width="1400px">
              <view-event-task
                v-if="taskId"
                :id="taskId"
                @updated="cancelDialogAndRefresh"
                @removed="cancelDialogAndRefresh"
                @cancel="cancelDialog"
              ></view-event-task>
            </v-dialog>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import PayrollForm from '../../components/forms/Payrolls/PayrollForm';
import PayrollsTaskList from '../../components/Payrolls/PayrollsTaskList';
import ViewEventTask from '@/modules/plannings/components/Event/ViewEventTask';

export default {
  name: 'PayrollsShowPage',

  components: {
    ViewEventTask,
    PayrollForm,
    PayrollsTaskList
  },

  mixins: [i18nRefreshData],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    payroll: {},
    employee: {},
    dialog: false,
    taskId: null,
    error: null
  }),

  computed: {
    ...mapGetters(['loading']),
    ...mapState('ereporter', ['currentInvoice'])
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapActions('ereporter', ['getPayroll']),
    refreshData() {
      this.getPayroll({ payrollId: this.id })
        .then(({ data }) => {
          this.payroll = data.data;
          this.employee = data.data.employee;
        })
        .catch(({ response }) => {
          this.payroll.tasks = [];
        });
    },
    show(item) {
      this.taskId = item.id;
      this.dialog = true;
    },
    cancelDialog() {
      this.dialog = false;
      this.taskId = null;
    },
    cancelDialogAndRefresh() {
      this.cancelDialog();
      this.refreshData();
    }
  }
};
</script>

<style scoped></style>
